import React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { camelize } from "humps";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  backgroundColor,
  borderColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";

export interface IProps {
  category: string;
  currentCategory: string;
  onClick: any;
}

export const CruiseVesselAttractionFilterButton: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { category, currentCategory, onClick } = props;
  const { t } = useTranslation(["component"]);

  const isActive = currentCategory === category;
  const buttonStyles = isActive ? buttonActiveStyle : buttonStyle;

  const onButtonClick = () => {
    onClick(category);
  };

  return (
    <div css={buttonStyles} onClick={onButtonClick}>
      {t(`constant:vesselAttractionCategory.${camelize(category)}`)}
    </div>
  );
};

const buttonStyle = css`
  padding: ${space.atom} ${space.atom2x};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSize.caption};
  line-height: ${lineHeight.caption2};
  color: ${textColor.secondaryDarkColor};
  font-weight: ${fontWeight.bold};
  border: 1px solid ${borderColor.secondaryLightColor};
  border-radius: 2rem;
  cursor: pointer;
  scroll-snap-align: start;
  flex-shrink: 0;
`;
const buttonActiveStyle = css`
  ${buttonStyle};
  background-color: ${textColor.primaryDarkColor};
  color: ${backgroundColor.primaryLightColor};
  border-color: ${textColor.primaryDarkColor};
`;
